<template>
    <div class="px-6 surface-overlay relative">
        <div class="py-0 lg:py-0 px-6 flex align-items-center justify-content-between lg:static">
            <div class="flex align-items-center">
                <a v-ripple class="cursor-pointer block lg:hidden text-700 p-ripple"
                   v-styleclass="{ selector: '#navbar-8', enterClass: 'hidden', leaveToClass: 'hidden', hideOnOutsideClick: true }">
                    <i class="pi pi-bars text-4xl"></i>
                </a>
            </div>
        </div>
        <div id="navbar-8"
             class="py-0 hidden lg:block absolute lg:static lg:w-auto w-full surface-overlay left-0 top-100 z-1 surface-border">
            <ul class="list-none p-0 m-0 flex lg:align-items-center flex-column lg:flex-row select-none">
                <li>
                    <a @click="processOverviewHome" v-ripple
                       class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                        <i class="pi pi-home mr-2"></i>
                        <span>Home</span>
                    </a>
                </li>
                <li v-show="this.userStore.user.rights != 'M'">
                    <a @click="processOverviewAuditTrail" v-ripple
                       class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                        <i class="pi pi-users mr-2"></i>
                        <span>Audit Trail</span>
                    </a>
                </li>
                <li v-show="this.userStore.user.rights != 'M'">
                    <a @click="processOverviewDashboard" v-ripple
                       class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                        <i class="pi pi-users mr-2"></i>
                        <span>Dashboards</span>
                    </a>
                </li>
                <li v-show="this.userStore.user.rights != 'M'">
                    <a @click="processOverviewReports" v-ripple
                       class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                        <i class="pi pi-users mr-2"></i>
                        <span>Reports</span>
                    </a>
                </li>
                <li v-show="this.userStore.user.rights != 'M'">
                    <a @click="processOverviewFiles" v-ripple
                       class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                        <i class="pi pi-users mr-2"></i>
                        <span>Files</span>
                    </a>
                </li>
                <li>
                    <a @click="processOverviewPlanning" v-ripple
                       class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                        <i class="pi pi-users mr-2"></i>
                        <span>Planning</span>
                    </a>
                </li>
                <li>
                    <a @click="processOverviewQualification" v-ripple
                       class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                        <i class="pi pi-users mr-2"></i>
                        <span>Qualification</span>
                    </a>
                </li>
            </ul>
        </div>
    </div>
</template>


<script>
import UserService from "@/service/UserService";
import {useUserStore} from "@/stores/UserStore";

export default {
    setup() {
        const userStore = useUserStore()

        return {
            userStore
        }
    },
    async mounted() {
        try {
            const userPingResponse = await UserService.getUserPing();
            console.log("[MenuPmModuleOverview][mounted] System is active.");
            console.log("[MenuPmModuleOverview][mounted] Data = ", userPingResponse);
        } catch (e) {
            console.log("[MenuPmModuleOverview][mounted] System is NOT active.");
            console.log("[MenuPmModuleOverview][mounted] Error = ", e);
            this.userStore.clearUser();
            this.$router.push("login");
            return;
        }

        if (!this.userStore.user.id) {
            console.log("[MenuPmModuleOverview][mounted] User is NOT defined.");
            this.userStore.clearUser();
            this.$router.push('login');
            return;
        }

        try {
            if (!this.userStore.user) {
                const userData = await UserService.getUser(this.userStore.user.id);
                this.profile = userData.data;

                console.log("[MenuPmModuleOverview][mounted] userData = ", userData);
            }

            this.profile = this.userStore.user;

            console.log("[MenuPmModuleOverview][mounted] this.profile = ", this.profile);

            this.loading = false;

        } catch (e) {
            console.error("[MenuPmModuleOverview][mounted] Error fetching additional data = ", e);
        }
    },
    data() {
        return {
            profile: {},
        }
    },
    methods: {
        processOverviewHome() {
            console.log("[MenuPmModuleOverview][processOverviewHome] Beginning.");
            window.location.href = "/#/pmOverviewHome";
        },
        processOverviewAuditTrail() {
            console.log("[MenuPmModuleOverview][processOverviewAuditTrail] Beginning.");
            window.location.href = "/#/commonOverviewAuditTrail";
        },
        processOverviewDashboard() {
            console.log("[MenuPmModuleOverview][processOverviewDashboard] Beginning.");
            window.location.href = "/#/commonOverviewDashboard";
        },
        processOverviewReports() {
            console.log("[MenuPmModuleOverview][processOverviewReports] Beginning.");
            window.location.href = "/#/commonOverviewReports";
        },
        processOverviewFiles() {
            console.log("[MenuPmModuleOverview][processOverviewFiles] Beginning.");
            window.location.href = "/#/commonOverviewFiles";
        },
        processOverviewPlanning() {
            console.log("[MenuPmModuleOverview][processOverviewPlanning] Beginning.");
            window.location.href = "/#/healthOverviewPlanning";
        },
        processOverviewQualification() {
            console.log("[MenuPmModuleOverview][processOverviewQualification] Beginning.");
            window.location.href = "/#/healthOverviewQualification";
        }

    }
};
</script>

<style scoped>
a {
    text-decoration: none;
}
</style>
